import React, { useState } from "react";

export default function FloatingField({
  id,
  label,
  placeholder,
  error,
  value,
  onChange,
  onBlur,
  type = "text",
  inputMode,
  autoComplete,
  readOnly = false,
  disabled = false,
  isNotMargin = false
}) {
  const [focused, setFocused] = useState(false);
  const filled =
    value !== undefined &&
    value !== null &&
    String(value).trim().length > 0;
  const floated = focused || filled;

  return (
    <div className="car-insurance__input-box-wrap" style={{ marginBottom: isNotMargin ? 0 : "" }}>
      <div
        className={`car-insurance__input-box${floated ? " car-insurance__input-box--floated" : ""
          }${error ? " car-insurance__input-box--error" : ""}${disabled ? " car-insurance__input-box--disabled" : ""}`}
      >
        <label className="car-insurance__input-box-label" htmlFor={id}>
          {label}
        </label>
        <input
          id={id}
          type={type}
          inputMode={inputMode}
          autoComplete={autoComplete}
          readOnly={readOnly}
          disabled={disabled}
          className="car-insurance__input-box-field"
          value={value || ""}
          onChange={onChange}
          onFocus={() => setFocused(true)}
          onBlur={(e) => {
            setFocused(false);
            if (onBlur) onBlur(e);
          }}
          placeholder={floated && placeholder ? placeholder : undefined}
        />
      </div>
      {error ? <div className="car-insurance__error">{error}</div> : null}
    </div>
  );
}
